import React from 'react';
import TourProvider, { TourStep } from '../tours/TourProvider';

interface ProjectTourProps {
  toursSeen: string[];
  markTourAsSeenUrl: string;
  translations: {
    header?: string;
    navigation?: string;
    description?: string;
  };
}

const ProjectTour: React.FC<ProjectTourProps> = ({ toursSeen, markTourAsSeenUrl, translations }) => {
  const steps: TourStep[] = [
    {
      selector: '#project-show-container .panel',
      content: translations.header || 'This is the project header. You can see the project name, level, and other key information here.',
    },
    {
      selector: '.nav-pills',
      content: translations.navigation || 'Navigate between different sections: the project description, quiz (if available), and resources.',
    },
    {
      selector: '#description',
      content: translations.description || 'Here you\'ll find the complete project description, requirements, and what you need to accomplish.',
    },
  ];

  return <TourProvider tourKey="project" steps={steps} toursSeen={toursSeen} markTourAsSeenUrl={markTourAsSeenUrl} />;
};

export default ProjectTour;

